import "@fontsource/roboto";
import "@fontsource-variable/roboto-mono";

export const FONT_FAMILY_ROBOTO = "'Roboto', sans-serif";
export const FONT_FAMILY_ROBOTO_MONO = "'Roboto Mono', monospace";
